import {Modal} from '@mantine/core';
import React, {useEffect, useState} from 'react';
import AggregateModalContainer from './AggregationModalContainer';
import {getAggregations} from "../../../../../../services/aggregationService";
import {useAuth} from "../../../../../../providers/AuthProvider";
import {AggregationInfo, KpiProps} from "../../../../../../types/types";
import "./AggregationModal.css"

export type ModalProps = {
    opened: boolean,
    setOpened: (flag: boolean) => void
}

export function AggregationModal(props: KpiProps & ModalProps) {
    const [aggregationList, setAggregationList] = useState<AggregationInfo[]>([]);

    const authContext = useAuth();

    //getting aggregation data from api and storing it into a state varaible while first time rendering the data.
    useEffect(() => {
        getUniqueAggregations()
            .then(aggregations => {
                setAggregationList(aggregations)
            });
        // eslint-disable-next-line
    }, []);

    async function getUniqueAggregations() {
        const aggregations = await getAggregations(authContext);
        const unique: Record<string, AggregationInfo> = {};
        aggregations.forEach((item) => {
            unique[item.aggregationName] = item;
        })
        return Object.values(unique);
    }


    return <>
        <Modal
            className="aggregation-modal-container"
            opened={props.opened}
            onClose={() => props.setOpened(false)}
            radius="lg"
            size="1000px"
        >
            <h2 className="aggregationModal__heading">Choose Dependent Aggregations</h2>
            <AggregateModalContainer {...props} aggregationList={aggregationList}/>
        </Modal>

    </>
}
